module.exports = __webpack_public_path__ + "img/ico-list.fec07d50.svg";